export const TWIN_API = "TWIN_API";
export const EXCALIBUR_STATUS = {
    FAILURE: "FAILURE",
    EXCEPTION: "EXCEPTION",
};
export const ERROR_REPORT_DOWNLOAD_FAILURE_FLASH = {
    type: "error",
    message: "Could not download error report"
};
